export const ADMIN_INTERNAL_PATH = "/admin";

export const ADMIN_PATHNAME_HEADER = "x-admin-pathname";

export function toAdminSubPathFromInternal(pathname: string): string {
  const raw = pathname.startsWith(ADMIN_INTERNAL_PATH)
    ? pathname.slice(ADMIN_INTERNAL_PATH.length)
    : pathname;

  return raw.replace(/\/+$/, "") || "/";
}

const ADMIN_BASE_ATTR = "data-admin-base";

function normalizeBase(raw: string | undefined | null): string {
  const trimmed = (raw ?? "").trim().replace(/^\/+|\/+$/g, "");
  return trimmed || "admin";
}

let runtimeAdminBase: string | null = null;

export function setRuntimeAdminBase(base: string | null): void {
  runtimeAdminBase = base === null ? null : normalizeBase(base);
}

export function getAdminBase(): string {
  if (typeof document !== "undefined") {
    return normalizeBase(
      document.documentElement.getAttribute(ADMIN_BASE_ATTR),
    );
  }

  return normalizeBase(runtimeAdminBase);
}

export function getAdminBasePath(): string {
  return `/${getAdminBase()}`;
}

export function isAdminPathCustomized(): boolean {
  return getAdminBase() !== "admin";
}

export function adminPath(sub = ""): string {
  const base = getAdminBasePath();

  if (!sub || sub === "/") {
    return base;
  }

  const suffix = sub.startsWith("/") ? sub : `/${sub}`;
  return `${base}${suffix}`;
}

export function isAdminExternalPath(pathname: string): boolean {
  const base = getAdminBasePath();
  return pathname === base || pathname.startsWith(`${base}/`);
}

export function toAdminInternalPath(pathname: string): string {
  const base = getAdminBasePath();

  if (pathname === base) {
    return ADMIN_INTERNAL_PATH;
  }

  if (pathname.startsWith(`${base}/`)) {
    return `${ADMIN_INTERNAL_PATH}${pathname.slice(base.length)}`;
  }

  return pathname;
}

export function isAdminInternalPath(pathname: string): boolean {
  return (
    pathname === ADMIN_INTERNAL_PATH ||
    pathname.startsWith(`${ADMIN_INTERNAL_PATH}/`)
  );
}

export function adminBaseAttrs(base: string): Record<string, string> {
  return { [ADMIN_BASE_ATTR]: normalizeBase(base) };
}
